import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_message = _resolveComponent("message")!
  const _component_resource_component = _resolveComponent("resource-component")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: `Resources ${this.resourceGroup.label}`,
    size: "lg",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
        dense: "",
        class: "text-grey",
        "active-color": "primary",
        "indicator-color": "primary",
        align: "justify",
        "narrow-indicator": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resourceTypes, (resourceType) => {
            return (_openBlock(), _createBlock(_component_q_tab, {
              key: resourceType.type,
              name: resourceType.type,
              label: resourceType.label
            }, null, 8, ["name", "label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_tab_panels, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
        animated: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resourceTypes, (resourceType) => {
            return (_openBlock(), _createBlock(_component_q_tab_panel, {
              key: resourceType.type,
              name: resourceType.type
            }, {
              default: _withCtx(() => [
                (!_ctx.resources.length)
                  ? (_openBlock(), _createBlock(_component_message, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(" No " + _toDisplayString(resourceType.label) + " resources. ", 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (resource) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: resource.title,
                    class: "q-mb-lg"
                  }, [
                    _createVNode(_component_resource_component, { resource: resource }, null, 8, ["resource"]),
                    _createVNode(_component_q_separator, { class: "q-mt-lg" })
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["title"]))
}